import Routes from 'config/routes';

export const getRouteRedirection = (route: Routes, filters: string) => {
  return { redirect: route, filters };
};
